import template from './peopleTypeahead.html';

const PeopleTypeaheadController = function controller(peopleService) {
  const $ctrl = this;

  const whichPeople = function determinePeopleType(type) {
    switch (type) {
      case 'user':
        return peopleService.getUsersByName;

      case 'author':
        return peopleService.getAuthorByName;

      default:
        return null;
    }
  };

  $ctrl.$onInit = () => {
    $ctrl.getPeople = name => whichPeople($ctrl.type)(name).then((data) => {
      $ctrl.people = data;
      return $ctrl.people;
    });

    if ($ctrl.inputType === 'multiple' && $ctrl.model) {
      // if there is any item without username property then create a username property
      $ctrl.model = $ctrl.model.map(val => (val.username ? val : { username: val }));
    }
  };

  $ctrl.selectPerson = (item) => {
    $ctrl.onSelect({ person: item });
  };
};


const controllerArr = [
  'peopleService',
  PeopleTypeaheadController
];

const component = {
  template,
  bindings: {
    required: '<',
    disabled: '<',
    blur: '&',
    focus: '<',
    disabledClass: '@',

    // For form validation purpose
    name: '@',

    // The type can be either author or user (must be provided)
    type: '@',

    // inputType could be 'single' or 'multiple'
    inputType: '@',

    // model for two-way binding
    model: '=',

    // placeholder should be a translation ID
    placeholder: '@',

    // onSelect should be a method to be called on selection of an item
    onSelect: '&',

    // onRemove should be a method to be called on removal of an item
    onRemove: '&',

    /* typeaheadConfig supports following configs:
     * editable
     * selectOnExact
     * selectOnBlur
     * focusOnSelect
     * appendToBody
     * */
    typeaheadConfig: '<'
  },
  controller: 'PeopleTypeaheadController'
};

export default function (ngModule) {
  ngModule.component('peopleTypeahead', component);
  ngModule.controller('PeopleTypeaheadController', controllerArr);
}
